export const errorUpdatingUser = (message) => `Error updating technician: ${message}.`;
export const updateUserSuccess = (message) => `Successfully updated: ${message}!`;
export const allowInvoicingLabel = 'Allow invoicing for this technician';
export const claimServiceDelayLabel = 'claim service delay (ms)';
export const claimServiceDelayPlaceholder = 'claim service delay (ms)...';
export const allowInvoicing = 'allow invoicing';
export const disableInvoicing = 'disable invoicing';
